// extracted by mini-css-extract-plugin
export default {"tableContainer":"table_tableContainer__QW4GQ","table":"table_table__mVwKK","content":"table_content__W+yFe"};